import { ButtonGroup, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)`
  height: 100%;
  border-radius: 0;
`;
export const ButtonWrapper = styled(ButtonGroup)``;
